var galleryPopup = function galleryPopup() {
  var popup = document.querySelector('.gallery-popup');
  var closeButton = document.querySelector('.gallery-popup__close');
  var overlayClose = document.querySelector('.gallery-popup-overlay');
  var galleryImages = document.querySelectorAll('.gallery-card__img');
  if (!popup) {
    return;
  }

  // Function to close the popup
  function closeGallery() {
    popup.style.display = 'none'; // Hide the popup
  }

  // Add a click event listener to the close button
  closeButton.addEventListener('click', closeGallery);
  overlayClose.addEventListener('click', closeGallery);
  var swiper = new Swiper('.gallery-popup__swiper', {
    slidesPerView: 'auto',
    navigation: {
      prevEl: '.gallery-popup-button-prev',
      nextEl: '.gallery-popup-button-next'
    }
  });

  // Open popup and show the corresponding slide
  galleryImages.forEach(function (image, index) {
    image.addEventListener('click', function () {
      var parent = image.closest('.gallery-card'); // Get parent element
      var dataIndex = parseInt(parent.getAttribute('data-index'), 10); // Get data-index
      popup.style.display = 'flex'; // Show popup
      swiper.slideTo(dataIndex); // Navigate to the corresponding slide
    });
  });
};
export { galleryPopup };